const windowObj = typeof window !== 'undefined' ? window : null;
export { windowObj as window };
